import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Unit } from '../../apiTypes';
import QntInput from '../QntInput';

type Props = {
  ingredient: {
    unit: Unit;
    qpp?: number | null;
  };
  name: string;
  defaultValue?: number;
  autoFocus?: boolean;
  disablePacking?: boolean;
  helperText?: string[];
  availableQnt?: number;
  canBeNegative?: boolean;
  disabled?: boolean;
};

const FormQntInput = ({ name, defaultValue, canBeNegative, ...rest }: Props) => {
  const { field } = useController({
    name,
    defaultValue,
    rules: {
      min: canBeNegative ? undefined : 0,
    },
  });

  const {
    formState: { errors },
  } = useFormContext<{ [key: string]: string }>();

  const error = errors[name];

  return <QntInput name={name} qnt={field.value} onChange={field.onChange} canBeNegative={canBeNegative} {...rest} />;
};

export default FormQntInput;
